import React from "react"
import { COLORS } from "../../../utilities/Constants"

const AppBtnToggler = ({ buttons, selectedBtn }) => {
	// template button: {title:"", onClick:()=>{}, key=""}
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				padding: 3,
				backgroundColor: COLORS.bg,
				border: `1px solid ${COLORS.border}`,
				borderRadius: 10,
			}}
		>
			{buttons.map((btn, i) => (
				<button
					key={`${btn.key}_${i}`}
					onClick={btn.onClick}
					style={{
						padding: "6px 16px",
						borderRadius: 8,
						border: "none",
						backgroundColor:
							selectedBtn === btn.title
								? COLORS.surface
								: "transparent",
						boxShadow:
							selectedBtn === btn.title
								? `0 1px 3px rgba(28,25,23,0.1)`
								: "none",
						color:
							selectedBtn === btn.title
								? COLORS.text
								: COLORS.textMuted,
						fontSize: 13,
						fontWeight: selectedBtn === btn.title ? 600 : 400,
						cursor: "pointer",
						fontFamily: "inherit",
						transition: "all 0.15s",
					}}
				>
					{btn.title}
				</button>
			))}
		</div>
	)
}

export default AppBtnToggler
